module.exports = __webpack_public_path__ + "img/21.59ac8a5e.png";